export default "__VITE_ASSET__C13rmxsP__"